/**
 * @generated SignedSource<<b3bcbf4488f0d1cd2fc874d66fb6d405>>
 * @relayHash 23cb4e40bd7969cab95cb86d883676d4
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 502cc5c1a0bff6fb07fc467304b835e586ecc2242804a08a106c0e4ba7f10ac6

import type { ConcreteRequest } from 'relay-runtime';
export type CcpEntitlementPreDunningStatus = "IN_PRE_DUNNING" | "NOT_IN_PRE_DUNNING" | "%future added value";
export type GrowthUnifiedProfileTrialTrigger = "AUTO_UPGRADE_MEDIA_STORAGE_LIMIT" | "AUTO_UPGRADE_STORAGE_LIMIT" | "AUTO_UPGRADE_USER_LIMIT" | "CROSSFLOW_REVERSE_TRIAL" | "CROSSFLOW_USER_LIMIT" | "EDITION_PARITY" | "EDITION_PARITY_AUTO_PROVISIONING" | "REACTIVATION" | "REVERSE_TRIAL" | "UI" | "%future added value";
export type GrowthUnifiedProfileTrialType = "AUTO_UPGRADE" | "DIRECT_TRIAL" | "MANUAL_TRIAL" | "REVERSE_TRIAL" | "%future added value";
export type JiraApplicationKey = "JIRA_CORE" | "JIRA_CUSTOMER_SERVICE" | "JIRA_PRODUCT_DISCOVERY" | "JIRA_SERVICE_DESK" | "JIRA_SOFTWARE" | "%future added value";
export type CommerceEntitlementFilter = {
  AND?: ReadonlyArray<CommerceEntitlementFilter | null> | null;
  OR?: ReadonlyArray<CommerceEntitlementFilter | null> | null;
  hasRelationshipFromWithType?: string | null;
  inPreDunning?: boolean | null;
  inTrialOrPreDunning?: boolean | null;
};
export type editionAwarenessQuery$variables = {
  applicationKey: JiraApplicationKey;
  chargeElement: string;
  cloudId: string;
  entitlementFilter?: CommerceEntitlementFilter | null;
  entitlementId: string;
  isServiceCollectionFree?: boolean | null;
  productKey: string;
  shouldCheckForAddPaymentDetails: boolean;
  shouldCheckForChargeQuantities: boolean;
  shouldCheckForDirectBuyChangeOffering: boolean;
  shouldCheckForPaymentDetails: boolean;
  shouldCheckForSinglePaidApp?: boolean | null;
  shouldCheckForStorageLimit: boolean;
  shouldCheckForStorageUsageJira: boolean;
  shouldCheckForSubscription: boolean;
  shouldCheckForTrial: boolean;
};
export type editionAwarenessQuery$data = {
  readonly csm_storage?: {
    readonly attachmentStorageAllowed: AGG$Long | null;
    readonly attachmentStorageIsUnlimited: boolean | null;
    readonly attachmentStorageUsed: AGG$Long | null;
  } | null;
  readonly growthUnifiedProfile_getEntitlementProfile?: {
    readonly availableCollectionSegments: ReadonlyArray<{
      readonly cannibalisationRiskSegment: string | null;
      readonly collectionOfferingId: string | null;
      readonly existingStandaloneApps: ReadonlyArray<{
        readonly entitlementId: string | null;
        readonly isAutoProvisionedUnactivated: boolean | null;
      }>;
    }>;
  } | null;
  readonly jira?: {
    readonly attachmentStorageAllowed?: AGG$Long | null;
    readonly attachmentStorageIsUnlimited?: boolean | null;
    readonly attachmentStorageUsed: AGG$Long | null;
  } | null;
  readonly jsm_storage?: {
    readonly attachmentStorageAllowed: AGG$Long | null;
    readonly attachmentStorageIsUnlimited: boolean | null;
    readonly attachmentStorageUsed: AGG$Long | null;
  } | null;
  readonly tenantContexts: ReadonlyArray<{
    readonly entitlementInfo: {
      readonly entitlement?: {
        readonly entitlementProfile: {
          readonly lastKnownTrial: {
            readonly createdAt: number | null;
            readonly offeringId: string | null;
            readonly trialEndTimeStamp: number | null;
            readonly trialTrigger: GrowthUnifiedProfileTrialTrigger | null;
            readonly trialType: GrowthUnifiedProfileTrialType | null;
          } | null;
        } | null;
        readonly experienceCapabilities: {
          readonly changeOfferingV2: {
            readonly experienceUrl: string | null;
            readonly isAvailableToUser: boolean | null;
          } | null;
          readonly changeOfferingV2WithSkipTrial?: {
            readonly experienceUrl: string | null;
            readonly isAvailableToUser: boolean | null;
          } | null;
        } | null;
        readonly latestUsageForChargeElement?: number | null;
        readonly offering?: {
          readonly key: string | null;
          readonly trial: {
            readonly lengthDays: number | null;
          } | null;
        } | null;
        readonly preDunning?: {
          readonly status: CcpEntitlementPreDunningStatus | null;
        } | null;
        readonly relatesFromEntitlementsWithCollectionType: ReadonlyArray<{
          readonly entitlement: {
            readonly entitlementProfile: {
              readonly lastKnownTrial: {
                readonly createdAt: number | null;
                readonly offeringId: string | null;
                readonly trialEndTimeStamp: number | null;
                readonly trialTrigger: GrowthUnifiedProfileTrialTrigger | null;
                readonly trialType: GrowthUnifiedProfileTrialType | null;
              } | null;
            } | null;
            readonly preDunning: {
              readonly status: CcpEntitlementPreDunningStatus | null;
            } | null;
          } | null;
          readonly entitlementId: string | null;
          readonly relationshipType: string | null;
        } | null> | null;
        readonly relatesFromEntitlementsWithEnterpriseType: ReadonlyArray<{
          readonly entitlementId: string | null;
          readonly relationshipType: string | null;
        } | null> | null;
        readonly subscription?: {
          readonly accountDetails: {
            readonly invoiceGroup: {
              readonly experienceCapabilities?: {
                readonly configurePaymentV2: {
                  readonly experienceUrl: string | null;
                  readonly isAvailableToUser: boolean | null;
                } | null;
              } | null;
              readonly invoiceable: boolean | null;
            } | null;
          } | null;
          readonly trial?: {
            readonly endTimestamp: number | null;
            readonly startTimestamp: number | null;
            readonly timeLeft: number | null;
          } | null;
        } | null;
        readonly transactionAccount: {
          readonly experienceCapabilities?: {
            readonly addPaymentMethodV2: {
              readonly experienceUrl: string | null;
              readonly isAvailableToUser: boolean | null;
            } | null;
          } | null;
          readonly isBillToPresent?: boolean | null;
          readonly isCurrentUserBillingAdmin: boolean | null;
          readonly key: string | null;
        } | null;
      } | null;
      readonly entitlementId: string;
    } | null;
  } | null> | null;
};
export type editionAwarenessQuery = {
  response: editionAwarenessQuery$data;
  variables: editionAwarenessQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "applicationKey"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "chargeElement"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "entitlementFilter"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "entitlementId"
},
v5 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "isServiceCollectionFree"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "productKey"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "shouldCheckForAddPaymentDetails"
},
v8 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "shouldCheckForChargeQuantities"
},
v9 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "shouldCheckForDirectBuyChangeOffering"
},
v10 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "shouldCheckForPaymentDetails"
},
v11 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "shouldCheckForSinglePaidApp"
},
v12 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "shouldCheckForStorageLimit"
},
v13 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "shouldCheckForStorageUsageJira"
},
v14 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "shouldCheckForSubscription"
},
v15 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "shouldCheckForTrial"
},
v16 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
},
v17 = [
  {
    "kind": "Variable",
    "name": "applicationKey",
    "variableName": "applicationKey"
  },
  (v16/*: any*/)
],
v18 = {
  "condition": "shouldCheckForStorageUsageJira",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "concreteType": "JiraQuery",
      "kind": "LinkedField",
      "name": "jira",
      "plural": false,
      "selections": [
        {
          "condition": "shouldCheckForStorageLimit",
          "kind": "Condition",
          "passingValue": true,
          "selections": [
            {
              "args": (v17/*: any*/),
              "kind": "ScalarField",
              "name": "attachmentStorageAllowed"
            },
            {
              "args": (v17/*: any*/),
              "kind": "ScalarField",
              "name": "attachmentStorageIsUnlimited"
            }
          ]
        },
        {
          "args": (v17/*: any*/),
          "kind": "ScalarField",
          "name": "attachmentStorageUsed"
        }
      ]
    }
  ]
},
v19 = [
  {
    "kind": "Literal",
    "name": "applicationKey",
    "value": "JIRA_SERVICE_DESK"
  },
  (v16/*: any*/)
],
v20 = [
  {
    "kind": "Literal",
    "name": "applicationKey",
    "value": "JIRA_CUSTOMER_SERVICE"
  },
  (v16/*: any*/)
],
v21 = {
  "condition": "isServiceCollectionFree",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "alias": "jsm_storage",
      "concreteType": "JiraQuery",
      "kind": "LinkedField",
      "name": "jira",
      "plural": false,
      "selections": [
        {
          "args": (v19/*: any*/),
          "kind": "ScalarField",
          "name": "attachmentStorageAllowed"
        },
        {
          "args": (v19/*: any*/),
          "kind": "ScalarField",
          "name": "attachmentStorageUsed"
        },
        {
          "args": (v19/*: any*/),
          "kind": "ScalarField",
          "name": "attachmentStorageIsUnlimited"
        }
      ]
    },
    {
      "alias": "csm_storage",
      "concreteType": "JiraQuery",
      "kind": "LinkedField",
      "name": "jira",
      "plural": false,
      "selections": [
        {
          "args": (v20/*: any*/),
          "kind": "ScalarField",
          "name": "attachmentStorageAllowed"
        },
        {
          "args": (v20/*: any*/),
          "kind": "ScalarField",
          "name": "attachmentStorageUsed"
        },
        {
          "args": (v20/*: any*/),
          "kind": "ScalarField",
          "name": "attachmentStorageIsUnlimited"
        }
      ]
    }
  ]
},
v22 = {
  "kind": "ScalarField",
  "name": "entitlementId"
},
v23 = {
  "condition": "shouldCheckForSinglePaidApp",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "args": [
        {
          "kind": "Variable",
          "name": "entitlementId",
          "variableName": "entitlementId"
        }
      ],
      "concreteType": "GrowthUnifiedProfileEntitlementProfileResult",
      "kind": "LinkedField",
      "name": "growthUnifiedProfile_getEntitlementProfile",
      "plural": false,
      "selections": [
        {
          "concreteType": "GrowthUnifiedProfileAvailableCollectionSegmentResult",
          "kind": "LinkedField",
          "name": "availableCollectionSegments",
          "plural": true,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "collectionOfferingId"
            },
            {
              "kind": "ScalarField",
              "name": "cannibalisationRiskSegment"
            },
            {
              "concreteType": "GrowthUnifiedProfileCollectionSegmentStandaloneAppResult",
              "kind": "LinkedField",
              "name": "existingStandaloneApps",
              "plural": true,
              "selections": [
                (v22/*: any*/),
                {
                  "kind": "ScalarField",
                  "name": "isAutoProvisionedUnactivated"
                }
              ]
            }
          ]
        }
      ]
    }
  ]
},
v24 = [
  {
    "items": [
      {
        "kind": "Variable",
        "name": "cloudIds.0",
        "variableName": "cloudId"
      }
    ],
    "kind": "ListValue",
    "name": "cloudIds"
  }
],
v25 = [
  {
    "kind": "Variable",
    "name": "hamsProductKey",
    "variableName": "productKey"
  }
],
v26 = [
  {
    "kind": "Variable",
    "name": "where",
    "variableName": "entitlementFilter"
  }
],
v27 = {
  "kind": "Literal",
  "name": "offeringName",
  "value": "Standard"
},
v28 = {
  "kind": "ScalarField",
  "name": "isAvailableToUser"
},
v29 = {
  "kind": "ScalarField",
  "name": "experienceUrl"
},
v30 = [
  (v28/*: any*/),
  (v29/*: any*/)
],
v31 = {
  "concreteType": "CcpEntitlementExperienceCapabilities",
  "kind": "LinkedField",
  "name": "experienceCapabilities",
  "plural": false,
  "selections": [
    {
      "args": [
        (v27/*: any*/)
      ],
      "concreteType": "CcpChangeOfferingExperienceCapability",
      "kind": "LinkedField",
      "name": "changeOfferingV2",
      "plural": false,
      "selections": (v30/*: any*/),
      "storageKey": "changeOfferingV2(offeringName:\"Standard\")"
    },
    {
      "condition": "shouldCheckForDirectBuyChangeOffering",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": "changeOfferingV2WithSkipTrial",
          "args": [
            (v27/*: any*/),
            {
              "kind": "Literal",
              "name": "skipTrial",
              "value": true
            }
          ],
          "concreteType": "CcpChangeOfferingExperienceCapability",
          "kind": "LinkedField",
          "name": "changeOfferingV2",
          "plural": false,
          "selections": (v30/*: any*/),
          "storageKey": "changeOfferingV2(offeringName:\"Standard\",skipTrial:true)"
        }
      ]
    }
  ]
},
v32 = {
  "condition": "shouldCheckForChargeQuantities",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "args": [
        {
          "kind": "Variable",
          "name": "chargeElement",
          "variableName": "chargeElement"
        }
      ],
      "kind": "ScalarField",
      "name": "latestUsageForChargeElement"
    }
  ]
},
v33 = {
  "concreteType": "CcpEntitlementPreDunning",
  "kind": "LinkedField",
  "name": "preDunning",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "status"
    }
  ]
},
v34 = {
  "concreteType": "CcpOfferingTrial",
  "kind": "LinkedField",
  "name": "trial",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "lengthDays"
    }
  ]
},
v35 = {
  "kind": "ScalarField",
  "name": "key"
},
v36 = {
  "condition": "shouldCheckForTrial",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "concreteType": "CcpTrial",
      "kind": "LinkedField",
      "name": "trial",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "timeLeft"
        },
        {
          "kind": "ScalarField",
          "name": "startTimestamp"
        },
        {
          "kind": "ScalarField",
          "name": "endTimestamp"
        }
      ]
    }
  ]
},
v37 = {
  "kind": "ScalarField",
  "name": "invoiceable"
},
v38 = {
  "condition": "shouldCheckForTrial",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "concreteType": "CcpInvoiceGroupExperienceCapabilities",
      "kind": "LinkedField",
      "name": "experienceCapabilities",
      "plural": false,
      "selections": [
        {
          "concreteType": "CcpConfigurePaymentMethodExperienceCapability",
          "kind": "LinkedField",
          "name": "configurePaymentV2",
          "plural": false,
          "selections": [
            (v29/*: any*/),
            (v28/*: any*/)
          ]
        }
      ]
    }
  ]
},
v39 = {
  "kind": "ScalarField",
  "name": "isCurrentUserBillingAdmin"
},
v40 = {
  "condition": "shouldCheckForPaymentDetails",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "concreteType": "CcpTransactionAccount",
      "kind": "LinkedField",
      "name": "transactionAccount",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "isBillToPresent"
        }
      ]
    }
  ]
},
v41 = {
  "condition": "shouldCheckForAddPaymentDetails",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "concreteType": "CcpTransactionAccount",
      "kind": "LinkedField",
      "name": "transactionAccount",
      "plural": false,
      "selections": [
        {
          "concreteType": "CcpTransactionAccountExperienceCapabilities",
          "kind": "LinkedField",
          "name": "experienceCapabilities",
          "plural": false,
          "selections": [
            {
              "concreteType": "CcpAddPaymentMethodExperienceCapability",
              "kind": "LinkedField",
              "name": "addPaymentMethodV2",
              "plural": false,
              "selections": (v30/*: any*/)
            }
          ]
        }
      ]
    }
  ]
},
v42 = {
  "kind": "ScalarField",
  "name": "relationshipType"
},
v43 = {
  "alias": "relatesFromEntitlementsWithEnterpriseType",
  "args": [
    {
      "kind": "Literal",
      "name": "relationshipTypes",
      "value": "ENTERPRISE"
    }
  ],
  "concreteType": "CcpEntitlementRelationship",
  "kind": "LinkedField",
  "name": "relatesFromEntitlements",
  "plural": true,
  "selections": [
    (v42/*: any*/),
    (v22/*: any*/)
  ],
  "storageKey": "relatesFromEntitlements(relationshipTypes:\"ENTERPRISE\")"
},
v44 = [
  {
    "kind": "Literal",
    "name": "relationshipTypes",
    "value": "COLLECTION"
  }
],
v45 = {
  "concreteType": "GrowthUnifiedProfileEntitlementProfileResult",
  "kind": "LinkedField",
  "name": "entitlementProfile",
  "plural": false,
  "selections": [
    {
      "concreteType": "GrowthUnifiedProfileEntitlementContextTrialResult",
      "kind": "LinkedField",
      "name": "lastKnownTrial",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "trialType"
        },
        {
          "kind": "ScalarField",
          "name": "trialTrigger"
        },
        {
          "kind": "ScalarField",
          "name": "trialEndTimeStamp"
        },
        {
          "kind": "ScalarField",
          "name": "createdAt"
        },
        {
          "kind": "ScalarField",
          "name": "offeringId"
        }
      ]
    }
  ]
},
v46 = {
  "kind": "ScalarField",
  "name": "id"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/),
      (v10/*: any*/),
      (v11/*: any*/),
      (v12/*: any*/),
      (v13/*: any*/),
      (v14/*: any*/),
      (v15/*: any*/)
    ],
    "kind": "Fragment",
    "name": "editionAwarenessQuery",
    "selections": [
      (v18/*: any*/),
      (v21/*: any*/),
      (v23/*: any*/),
      {
        "args": (v24/*: any*/),
        "concreteType": "TenantContext",
        "kind": "LinkedField",
        "name": "tenantContexts",
        "plural": true,
        "selections": [
          {
            "args": (v25/*: any*/),
            "kind": "LinkedField",
            "name": "entitlementInfo",
            "plural": false,
            "selections": [
              (v22/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "args": (v26/*: any*/),
                    "concreteType": "CcpEntitlement",
                    "kind": "LinkedField",
                    "name": "entitlement",
                    "plural": false,
                    "selections": [
                      (v31/*: any*/),
                      (v32/*: any*/),
                      {
                        "condition": "shouldCheckForTrial",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          (v33/*: any*/),
                          {
                            "concreteType": "CcpOffering",
                            "kind": "LinkedField",
                            "name": "offering",
                            "plural": false,
                            "selections": [
                              (v34/*: any*/),
                              (v35/*: any*/)
                            ]
                          }
                        ]
                      },
                      {
                        "condition": "shouldCheckForSubscription",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "concreteType": "CcpSubscription",
                            "kind": "LinkedField",
                            "name": "subscription",
                            "plural": false,
                            "selections": [
                              (v36/*: any*/),
                              {
                                "concreteType": "CcpAccountDetails",
                                "kind": "LinkedField",
                                "name": "accountDetails",
                                "plural": false,
                                "selections": [
                                  {
                                    "concreteType": "CcpInvoiceGroup",
                                    "kind": "LinkedField",
                                    "name": "invoiceGroup",
                                    "plural": false,
                                    "selections": [
                                      (v37/*: any*/),
                                      (v38/*: any*/)
                                    ]
                                  }
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      {
                        "concreteType": "CcpTransactionAccount",
                        "kind": "LinkedField",
                        "name": "transactionAccount",
                        "plural": false,
                        "selections": [
                          (v35/*: any*/),
                          (v39/*: any*/)
                        ]
                      },
                      (v40/*: any*/),
                      (v41/*: any*/),
                      (v43/*: any*/),
                      {
                        "alias": "relatesFromEntitlementsWithCollectionType",
                        "args": (v44/*: any*/),
                        "concreteType": "CcpEntitlementRelationship",
                        "kind": "LinkedField",
                        "name": "relatesFromEntitlements",
                        "plural": true,
                        "selections": [
                          (v42/*: any*/),
                          (v22/*: any*/),
                          {
                            "concreteType": "CcpEntitlement",
                            "kind": "LinkedField",
                            "name": "entitlement",
                            "plural": false,
                            "selections": [
                              (v33/*: any*/),
                              (v45/*: any*/)
                            ]
                          }
                        ],
                        "storageKey": "relatesFromEntitlements(relationshipTypes:\"COLLECTION\")"
                      },
                      (v45/*: any*/)
                    ]
                  }
                ],
                "type": "CommerceEntitlementInfoCcp"
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v6/*: any*/),
      (v9/*: any*/),
      (v15/*: any*/),
      (v14/*: any*/),
      (v8/*: any*/),
      (v3/*: any*/),
      (v1/*: any*/),
      (v13/*: any*/),
      (v0/*: any*/),
      (v12/*: any*/),
      (v10/*: any*/),
      (v7/*: any*/),
      (v5/*: any*/),
      (v4/*: any*/),
      (v11/*: any*/)
    ],
    "kind": "Operation",
    "name": "editionAwarenessQuery",
    "selections": [
      {
        "args": (v24/*: any*/),
        "concreteType": "TenantContext",
        "kind": "LinkedField",
        "name": "tenantContexts",
        "plural": true,
        "selections": [
          {
            "args": (v25/*: any*/),
            "kind": "LinkedField",
            "name": "entitlementInfo",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "__typename"
              },
              (v22/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "args": (v26/*: any*/),
                    "concreteType": "CcpEntitlement",
                    "kind": "LinkedField",
                    "name": "entitlement",
                    "plural": false,
                    "selections": [
                      (v31/*: any*/),
                      {
                        "concreteType": "CcpTransactionAccount",
                        "kind": "LinkedField",
                        "name": "transactionAccount",
                        "plural": false,
                        "selections": [
                          (v35/*: any*/),
                          (v39/*: any*/),
                          (v46/*: any*/)
                        ]
                      },
                      (v43/*: any*/),
                      {
                        "alias": "relatesFromEntitlementsWithCollectionType",
                        "args": (v44/*: any*/),
                        "concreteType": "CcpEntitlementRelationship",
                        "kind": "LinkedField",
                        "name": "relatesFromEntitlements",
                        "plural": true,
                        "selections": [
                          (v42/*: any*/),
                          (v22/*: any*/),
                          {
                            "concreteType": "CcpEntitlement",
                            "kind": "LinkedField",
                            "name": "entitlement",
                            "plural": false,
                            "selections": [
                              (v33/*: any*/),
                              (v45/*: any*/),
                              (v46/*: any*/)
                            ]
                          }
                        ],
                        "storageKey": "relatesFromEntitlements(relationshipTypes:\"COLLECTION\")"
                      },
                      (v45/*: any*/),
                      (v46/*: any*/),
                      (v32/*: any*/),
                      {
                        "condition": "shouldCheckForTrial",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          (v33/*: any*/),
                          {
                            "concreteType": "CcpOffering",
                            "kind": "LinkedField",
                            "name": "offering",
                            "plural": false,
                            "selections": [
                              (v34/*: any*/),
                              (v35/*: any*/),
                              (v46/*: any*/)
                            ]
                          }
                        ]
                      },
                      {
                        "condition": "shouldCheckForSubscription",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "concreteType": "CcpSubscription",
                            "kind": "LinkedField",
                            "name": "subscription",
                            "plural": false,
                            "selections": [
                              (v36/*: any*/),
                              {
                                "concreteType": "CcpAccountDetails",
                                "kind": "LinkedField",
                                "name": "accountDetails",
                                "plural": false,
                                "selections": [
                                  {
                                    "concreteType": "CcpInvoiceGroup",
                                    "kind": "LinkedField",
                                    "name": "invoiceGroup",
                                    "plural": false,
                                    "selections": [
                                      (v37/*: any*/),
                                      (v38/*: any*/),
                                      (v46/*: any*/)
                                    ]
                                  }
                                ]
                              },
                              (v46/*: any*/)
                            ]
                          }
                        ]
                      },
                      (v40/*: any*/),
                      (v41/*: any*/)
                    ]
                  }
                ],
                "type": "CommerceEntitlementInfoCcp"
              }
            ]
          }
        ]
      },
      (v18/*: any*/),
      (v21/*: any*/),
      (v23/*: any*/)
    ]
  },
  "params": {
    "id": "502cc5c1a0bff6fb07fc467304b835e586ecc2242804a08a106c0e4ba7f10ac6",
    "metadata": {},
    "name": "editionAwarenessQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "5e801f7f51406b36c237c45ddeb9ecf7";

export default node;
